import React, { Fragment, useState, useEffect } from "react";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const SelectorTemplate = ({ typeProcedure, onChangeTemplate, disabled }) => {

    const [procedureTemplate, setProcedureTemplate] = useState(null);
    const [procedureTemplateList, setProcedureTemplateList] = useState([]);

    useEffect(() => {
        getProcedureTemplate();
    }, []);

    const getProcedureTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas-procedimientos/consultar-por-tipo', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                tipo: typeProcedure
            })
        }).then(response => {
            if (response.status == 200) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            setProcedureTemplateList(data);
        }).catch((error) => {
            setProcedureTemplateList([]);
        });
    }

    const handlerProcedureTemplate = (value) => {
        setProcedureTemplate(value);
        let template = procedureTemplateList.find(temp => temp.id_historia_plantilla_procedimientos == value);
        onChangeTemplate(template);
    }

    return (
        <Fragment>
            <TextField
                id="selectorProcedureTemplate"
                label="Selección de Plantilla"
                select
                value={procedureTemplate}
                disabled={disabled}
                className='medical-material-form__field'
                onChange={(event) => {
                    handlerProcedureTemplate(event.target.value);
                }}
                InputLabelProps={{
                    style: { color: '#646777' },
                    shrink: procedureTemplate != null ? true : false
                }}
                style={{ minWidth: '100%', maxWidth: '100%' }}
            >
                {procedureTemplateList.map((templateProcedure) => {
                    return <MenuItem key={templateProcedure.id_historia_plantilla_procedimientos} value={templateProcedure.id_historia_plantilla_procedimientos}>
                        {templateProcedure.plantilla}
                    </MenuItem>
                })}
            </TextField>
        </Fragment>
    );
}
export default SelectorTemplate;